import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useHistorialEstados(leadId) {
  return useQuery({
    queryKey: ['historial', leadId],
    queryFn: () => api.get(`/estados/${leadId}/historial`).then((r) => r.data),
    enabled: !!leadId,
  });
}

export function useCambiarEstado(leadId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (estado_nuevo) => api.post(`/estados/${leadId}`, { estado_nuevo }).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['lead', leadId] });
      qc.invalidateQueries({ queryKey: ['historial', leadId] });
    },
  });
}

export const ESTADOS_CATEGORIAS = {
  activo: ['Nuevo', 'Compromiso', 'Lo pensará', 'Llamar', 'Contraturno', 'Convenio'],
  neutro: ['No contesta'],
  conversion: ['Ingreso', 'Reincorporación'],
  perdida: ['No quiere hacerlo'],
  descalificado: ['Alumno 6to', 'Otra provincia', 'Menor', 'Duplicado', 'Ya es alumno', 'Dato erróneo', 'No pidió info', 'Averigua para 3ro'],
};

export const TODOS_LOS_ESTADOS = Object.values(ESTADOS_CATEGORIAS).flat();
